export const deptForm: any = {
  realm: "",
  entityName: "",
  description: "",
  location: {},
  functionId: {},
  businessType: "",
  users: [],
  sections: [],
  entityId: "",
  locationId: "",
  entityUserId: "",
  businessTypeId: "",
  id: "",
  createdAt: "",
};
